import React from "react";

function Footer() {
  const today = new Date();
  const year = today.getFullYear();
  return (
    <div>
      <div className="footer p-0 text-center">
        <div className="copyright">
          <h6>© {year} Defin, All Rights Reserved.</h6>
        </div>
      </div>
    </div>
  );
}

export default Footer;
